import {
  Injectable
} from '@angular/core';
import {
  UserInfo
} from '../../models';

import {
  UserToken
} from '../../models';
import {BehaviorSubject} from 'rxjs';
import {ApiService} from '../api';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Title} from '@angular/platform-browser';

@Injectable()
export class UserContext {
  private currentUser: UserInfo;
  private userToken: UserToken;
  private userAccount: any;
  public appointments: any[] = [];

  userInfoObserver: BehaviorSubject<UserInfo> = new BehaviorSubject<UserInfo>(null);
  accountObserver: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  appointmentsObserver: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);

  constructor(private api:ApiService,
              private title:Title,
              private jwtHelperService: JwtHelperService) {

  }

  get account(): any {
    if (this.userAccount) {
      //console.log("Returning account: " + JSON.stringify(this.userAccount));
      return this.userAccount;
    }
    this.userAccount = JSON.parse(localStorage.getItem('account')) as any;
    //console.log("Returning account from storage: " + JSON.stringify(this.userAccount));
    if (this.userAccount) {
      this.accountObserver.next(this.userAccount);
      this.fetchRequests();
      return this.userAccount;
    }
  }

  public fetchAccount(accountId?:string) {
    if(this.currentUser.account_id || accountId) {
      this.api.get<any>(`/account/${this.currentUser.account_id || accountId}`).subscribe(result => {
        this.account = result;
        this.accountObserver.next(this.account);

        this.fetchRequests();
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
    }
  }

  public fetchRequests() {
    if( this.account ) {
      this.api.get<any>(`/account/${this.account.id}/appointment`).subscribe(result => {
        this.appointments = result;
        this.appointmentsObserver.next(this.appointments);
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
    }
  }

  set account(account:any) {
    this.userAccount = account;
    localStorage.setItem('account', JSON.stringify(account));
    this.accountObserver.next(this.userAccount);
  }

  get user(): UserInfo {
    if (this.currentUser) {
      return this.currentUser;
    }

    this.currentUser = JSON.parse(localStorage.getItem('userInfo' )) as UserInfo;

    if (this.currentUser) {
      //console.log("Fetching locations after reload");
      this.userInfoObserver.next(this.currentUser);
    }
    return this.currentUser;
  }

  set user(user: UserInfo) {
    this.currentUser = user;
    localStorage.setItem('userInfo', JSON.stringify(user));
  }

  get token(): UserToken {
    if (this.userToken) {
      return this.userToken;
    }

    this.userToken = JSON.parse(localStorage.getItem('token' )) as UserToken;
    if( this.userToken ) {
      if( !this.userToken.idToken && this.userToken.id_token )
        this.userToken.idToken = this.userToken.id_token;
      if( !this.userToken.accessToken && this.userToken.access_token )
        this.userToken.accessToken = this.userToken.access_token;
      //console.log("Loaded id token: " + JSON.stringify(this.userToken));
      this.update(this.jwtHelperService.decodeToken(this.userToken.idToken));
    }

    return this.userToken;
  }

  set token(token: UserToken) {
    this.userToken = token;
    localStorage.setItem('token', JSON.stringify(token));
    //console.log("decoding token: " + JSON.stringify(this.userToken));
    if( this.userToken ) {
      try {
        this.update(this.jwtHelperService.decodeToken(this.userToken.idToken));
      } catch( err ) {
        console.log("Failed to decode token.");
        //this.clear();
      }
    }
  }

  /**
   * fillInfo
   * @param obj
   */
  public update(obj: any): void {
    Object.assign(obj, {
      role: obj['https://orthoteks.com/role'],
      roles: obj['https://orthoteks.com/roles'],
      account_id: obj['https://orthoteks.com/account'],
      supplier_id: obj['https://orthoteks.com/supplier'],
      distributor_id: obj['https://orthoteks.com/distributor'],
      reference: obj['https://orthoteks.com/reference'],
      user_id: obj['sub']
    });
    //console.log('Updated current user: ' + JSON.stringify(obj));

    this.currentUser = Object.assign(this.currentUser || {}, obj);
    this.userInfoObserver.next(this.currentUser);
  }

  public hasRole(roleName: string) {
    return this.user && ((this.user.role || "").includes(roleName) || (this.user.roles || "").includes(roleName));
  }

  public isAdministrator() {
    return this.hasRole('administrator');
  }

  public isManager() {
    return this.hasRole('manager');
  }

  public isAssociate() {
    return this.hasRole('associate');
  }

  public accountHasOption(option:string) {
    return ((this.account || {}).options || []).includes(option);
  }

  public isSupplier() {
    return this.user && this.user.supplier_id;
  }

  public isDistributor() {
    return this.user && this.user.distributor_id;
  }

  public resetAccount(): void {
    this.account = null;
  }

  /**
   * clearInfo
   */
  public clear(): void {
    localStorage.removeItem('userInfo');
    localStorage.removeItem('token');
    localStorage.removeItem('account');

    this.userToken = null;
    this.currentUser = null;
    this.account = null;
  }
}
